import { Component, OnInit } from '@angular/core';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import { AuthService } from 'app/auth/auth.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import * as backInter from 'app/auth/auth-data.model';
import { fuseAnimations } from '@fuse/animations';

///IDIOMAS
import { lang_resultados } from 'app/idiomas/i18n/resultados/resultados.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

@Component({
  selector: 'app-forall-resultados-viejos',
  templateUrl: './forall-resultados-viejos.component.html',
  styleUrls: ['./forall-resultados-viejos.component.scss'],
  animations : fuseAnimations
})
export class ForallResultadosViejosComponent implements OnInit {
  regionBG:string;
  urlForall:any;
  urlSafe: SafeResourceUrl;
  ValidarForallHeredada:boolean=false;
  constructor(
    private wizardService: WizardService,
    private authService: AuthService,
    public sanitizer: DomSanitizer,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService
  ) {
    lang_resultados.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  this.obtieneInstituto();
  }

  obtieneInstituto(){
    let institutoAct = this.wizardService.getInstituto();
    console.log("instituto");
    console.log(institutoAct);
    this.producto();
    switch(institutoAct){
      //referencia de institutos en component colaboradores
      case '3': case '4': case '5': case '6': this.regionBG = 'REG1';
      case '1': case '2': this.regionBG = 'REG2';
      case '7': this.regionBG = 'REG3';
    }

  }

  producto(){
    console.log("Productos brothar");
    let infoUsuario = this.authService.getInfoUsuario();
    if(infoUsuario.level == 1){
      this.wizardService.getProductos().subscribe((data:backInter.infoProductos)=>{
        console.log("Porductos",data);
        data.productosResultados4all.forEach(element => {
          if(element.link){
            //console.log(element.link);
            this.urlForall=element.link;
            this.ValidarForallHeredada=true;
          }
        })
        console.log(data.productosResultados4all);
        this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.urlForall);
      });
    }
  }

  ngOnInit() {
  }

}
